import React, { useContext } from 'react'
import Rating from '@mui/material/Rating';
import ThemeContext from '../../Context/theme/ThemeContext';

const RatingComp = ({ FirstName , LastName, key, ProfileImage, Country, rating, reviewMessage, date}) => {

    const daysBefore = (timeStamp) => {
        const date = new Date(timeStamp);
        const currentDate = new Date();
        const diffTime = Math.abs(currentDate - date);

        if (diffTime < 1000 * 60 * 60 * 24) {
            return 0;
        }

        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    };


    const{theme}=useContext(ThemeContext);
    return (
        <div className='py-2 font-pop'>
            <div className="flex flex-col lg:flex-row gap-0 font-pop justify-between">
                <div className="flex flex-row gap-1">
                    {
                        ProfileImage ? <img src={ProfileImage} alt="" className='w-8 h-8 rounded-full' /> :
                            (<div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center">
                                <h1 className="text-base font-semibold text-lightGrey">{FirstName[0]}</h1>
                            </div>)
                    }

                    <div className="flex flex-col gap-0">
                        <h3 className={`text-base font-semibold   ${
                     theme == "dark" && "text-white"
                   }`}>{FirstName} {LastName}</h3>
                        <h4 className={` text-lightGrey ${
                     theme == "dark" && "text-white"
                   }`}>{Country}</h4>
                    </div>
                </div>
                <div className="flex flex-col ">
                    <div className=" font-medium py-1 px-2 h-fit w-fit flex flex-row items-center gap-2 text-black rounded-3xl">
                        {rating.toFixed(1)} <Rating precision={0.1} name="read-only" value={rating.toFixed(1)} readOnly />
                    </div>
                    <h4 className={`ml-3 text-sm text-lightGrey
                      ${
                     theme == "dark" && "text-white"
                   }`}>{daysBefore(date)} days ago</h4>
                </div>
            </div>
            <p className='my-2 text-sm text-center'>{reviewMessage}</p>
        </div>
    )
}

export default RatingComp